import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { resetPaperTrades } from "../../actions/deal-action";
import { PaperExchange } from "../../Const";
import ConfirmationModal from "../common/ConfirmationModal";
import "./PaperTradeResetActions.scss";

const PaperTradeResetActions = ({ exchangeId, resetPaperTrades, onResetComplete }) => {
  const { t } = useTranslation();
  const [resetMode, setResetMode] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const submittingRef = useRef(false);
  const mountedRef = useRef(true);
  const fullReset = resetMode === "full";

  useEffect(() => () => { mountedRef.current = false; }, []);
  useEffect(() => { setResetMode(null); }, [exchangeId]);

  const handleCancel = () => {
    if (!submittingRef.current) setResetMode(null);
  };

  const handleConfirm = async () => {
    if (!resetMode || submittingRef.current) return;
    submittingRef.current = true;
    setIsSubmitting(true);

    try {
      const message = await resetPaperTrades(exchangeId, fullReset);
      toast.success(message || t(fullReset ? "paper-trades-full-reset-success" : "paper-trades-reset-success"));
      if (mountedRef.current) setResetMode(null);
      // A refresh failure must not be reported as a failed destructive operation.
      try {
        await onResetComplete(exchangeId);
      } catch (error) {
        toast.error(t("paper-trades-reset-refresh-error"));
      }
    } catch (error) {
      toast.error(error?.message || error || t("paper-trades-reset-error"));
    } finally {
      submittingRef.current = false;
      if (mountedRef.current) setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="paper-trade-reset-actions">
        {exchangeId === PaperExchange.id && (
          <button type="button" className="paper-trade-reset-actions__button paper-trade-reset-actions__button--full"
            disabled={isSubmitting} onClick={() => setResetMode("full")}>
            {t("paper-trades-full-reset")}
          </button>
        )}
        <button type="button" className="paper-trade-reset-actions__button"
          disabled={isSubmitting} onClick={() => setResetMode("completed")}>
          {t("paper-trades-reset")}
        </button>
      </div>
      <ConfirmationModal
        show={resetMode !== null}
        title={t(fullReset ? "paper-trades-full-reset-title" : "paper-trades-reset-title")}
        body={t(fullReset ? "paper-trades-full-reset-warning" : "paper-trades-reset-warning")}
        onCancel={handleCancel}
        onConfirm={handleConfirm}
        confirmText={t(isSubmitting ? "paper-wallet-resetting" : fullReset ? "paper-trades-full-reset" : "paper-trades-reset")}
        cancelText={t("cancel")}
        confirmButtonClass="red-button"
        isSubmitting={isSubmitting}
      />
    </>
  );
};

export default connect(null, { resetPaperTrades })(PaperTradeResetActions);
